import React, { useState } from 'react';
import { ReactComponent as OptionRemove } from '../../assets/svg/DeleteContent.svg';
import { Tooltip as ReactTooltip } from 'react-tooltip';

function CourseSingleDay({
	provided,
	currentDay,
	index,
	setCurrentDay,
	days,
	setIndexDayForDelete,
	setDeleteDay,
}: {
	provided: any;
	currentDay: any;
	index: number;
	setCurrentDay: any;
	days: any;
	setIndexDayForDelete: any;
	setDeleteDay: any;
}) {
	const [hoveredDay, setHoveredDay] = useState(false);
	return (
		<div
			className={`rounded-[10px] pointer text-sm p-[10px] font-semibold flex-1 flex items-center justify-center not-selectable whitespace-nowrap max-w-[100px] mr-[10px] relative ${
				index === currentDay ? 'bg-primaryViolet text-brandYellow' : 'bg-greyBackground hover:bg-greyLight text-primaryViolet'
			}`}
			key={index}
			onClick={() => {
				setCurrentDay(index);
			}}
			onMouseEnter={() => setHoveredDay(true)}
			onMouseLeave={() => setHoveredDay(false)}
			ref={provided.innerRef}
			{...provided.draggableProps}
			{...provided.dragHandleProps}
		>
			Day {(index + 1).toString()}
			{days.length > 1 && hoveredDay && (
				<div
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						setIndexDayForDelete(index);
						setDeleteDay(true);
					}}
					className='cursor-pointer absolute max-h-[18px] flex items-center justify-center  -right-[4px] -top-[8px] bg-white rounded-full '
					data-tip={`Delete day`}
					data-for='poll-option-remove'
				>
					<OptionRemove fill='#FFA28D' />
					{/* <ReactTooltip id='poll-option-remove' arrowColor='#5E639B' className='' /> */}
				</div>
			)}
		</div>
	);
}

export default CourseSingleDay;
